// `name` in each of these maps to values we create by pulling values out of
// the `<InsurancePolicy>` when previewing changes due to a `<TransactionRequest>`
export var insuredCancelPreviewFields = [{
  label: "Cancellation Type",
  name: "cancellationType"
}, {
  label: "Cancellation Reason",
  name: "cancellationReason"
}, {
  label: "Change In Premiums",
  name: "changeInPremiums",
  type: "currency"
}, {
  label: "Change In Fees",
  name: "changeInFees",
  type: "currency"
}, {
  label: "Change In Taxes",
  name: "changeInTaxes",
  type: "currency"
}, {
  label: "Change In Others",
  name: "changeInOthers",
  type: "currency"
}, {
  label: "Total Change",
  name: "totalChange",
  type: "currency"
}]; // Most actions which result in a change in premium require that you show these
// values on the preview page. When the response comes back from the server,
// we look through the XML for the `name` and
// @TODO

export var termPremiumInputs = [{
  label: "Premium Before Fees",
  name: "GrandSubtotal",
  nameSelector: "Terms Term:last-child DataItem[name='OpGrandSubtotal']",
  change: "AccountingChangeGrandSubtotal",
  changeSelector: "Terms Term:last-child DataItem[name='AccountingChangeGrandSubtotal']"
}, {
  label: "Fees & Taxes",
  name: "TotalFees",
  change: "AccountingChangeTotalFees"
}, {
  label: "Surplus Contribution",
  name: "SurplusContribution",
  change: "AccountingChangeSurplusContribution"
}, {
  label: "Total Premium",
  labelKey: "TotalPremiumLabel",
  name: "TotalPremium",
  change: "AccountingChangeTotalPremium"
}];